import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { PromotionType } from "../../../interfaces/promotionType";
import { getFullDateFormat } from "../../../utils/dateFormater";

type PromotionTableProps = {
  data: PromotionType[];
  isLoading: boolean;
} & Pick<
  DataTableProps<PromotionType>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<PromotionType>[] = [
  { key: "promotionName", label: "Nombre de la promoción" },
  { key: "distributorTypes", label: "Tipo de distribuidores" },
  { key: "promotionStartAt", label: "Fecha de inicio", isDate: true },
  { key: "promotionEndsAt", label: "Fecha de fin", isDate: true },
  { key: "active", label: "Activa", isBoolean: true },
];

export const PromotionTable = (props: PromotionTableProps) => {
  const { isLoading, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="promotion-table"
      customRender={(key, item) => {
        if (key === "distributorTypes") {
          if (!item?.distributorTypes) return "";
          return item.distributorTypes.map((i) => i.name).join(", ");
        }
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        if (key === "promotionStartAt" || key === "promotionEndsAt") {
          if (item[key]) return getFullDateFormat(item[key] as Date);
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
